module.exports = __webpack_public_path__ + "static/media/PackageHoldLogoWhite.178b547e.png";